var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgConfirmationIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "224px",
    height: "200px",
    viewBox: "0 0 224 200",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Confirmation - Pending Contracts - Saved Card Copy") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "8.73554113 15.2571623 18.5857062 -1.13269383e-13 21.9192166 2.43061697 9.33719648 21.9192166 0 12.1403049 2.83764384 9.08025285"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "path-3",
    x: 0,
    y: 0,
    width: 40.8494492,
    height: 40.8494492
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-34.3%",
    y: "-24.5%",
    width: "168.5%",
    height: "168.5%",
    filterUnits: "objectBoundingBox",
    id: "filter-4"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 4,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowBlurOuter1",
    in2: "SourceAlpha",
    operator: "out",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0.341176471   0 0 0 0 0.721568627  0 0 0 0.0625566123 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Confirmation---Pending-Contracts---Saved-Card-Copy",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6-Copy",
    transform: "translate(43.000000, 43.000000)",
    fill: "#1352DE"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.674,6.816 C5.147,6.816 4.718,7.244 4.718,7.772 L4.718,9.989 C4.718,10.517 5.147,10.944 5.674,10.944 C6.201,10.944 6.63,10.517 6.63,9.989 L6.63,7.772 C6.63,7.244 6.201,6.816 5.674,6.816",
    id: "Fill-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.173,4.592 L0.955,4.592 C0.428,4.592 -4.26325641e-14,5.02 -4.26325641e-14,5.548 C-4.26325641e-14,6.076 0.428,6.504 0.955,6.504 L3.173,6.504 C3.7,6.504 4.128,6.076 4.128,5.548 C4.128,5.02 3.7,4.592 3.173,4.592",
    id: "Fill-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.674,8.48210391e-14 C5.147,8.48210391e-14 4.718,0.427 4.718,0.955 L4.718,3.171 C4.718,3.699 5.147,4.127 5.674,4.127 C6.201,4.127 6.63,3.699 6.63,3.171 L6.63,0.955 C6.63,0.427 6.201,8.48210391e-14 5.674,8.48210391e-14",
    id: "Fill-8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.393,4.44 L8.175,4.44 C7.648,4.44 7.22,4.868 7.22,5.396 C7.22,5.924 7.648,6.352 8.175,6.352 L10.393,6.352 C10.921,6.352 11.349,5.924 11.349,5.396 C11.349,4.868 10.921,4.44 10.393,4.44",
    id: "Fill-9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-6-Copy-2",
    transform: "translate(184.000000, 146.000000)",
    fill: "#1352DE"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.5,12 C8.67311715,12 8,12.7257752 8,13.621124 L8,17.3805717 C8,18.2759205 8.67311715,19 9.5,19 C10.3268828,19 11,18.2759205 11,17.3805717 L11,13.621124 C11,12.7257752 10.3268828,12 9.5,12",
    id: "Fill-6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.38057171,8 L1.61942829,8 C0.725775194,8 0,8.67154812 0,9.5 C0,10.3284519 0.725775194,11 1.61942829,11 L5.38057171,11 C6.27422481,11 7,10.3284519 7,9.5 C7,8.67154812 6.27422481,8 5.38057171,8",
    id: "Fill-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5,0 C8.67311715,0 8,0.724254907 8,1.61982069 L8,5.37848316 C8,6.27404895 8.67311715,7 9.5,7 C10.3268828,7 11,6.27404895 11,5.37848316 L11,1.61982069 C11,0.724254907 10.3268828,0 9.5,0",
    id: "Fill-8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3792686,8 L13.6190361,8 C12.7255994,8 12,8.67154812 12,9.5 C12,10.3284519 12.7255994,11 13.6190361,11 L17.3792686,11 C18.2744006,11 19,10.3284519 19,9.5 C19,8.67154812 18.2744006,8 17.3792686,8",
    id: "Fill-9"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M27.569,165 C27.569,165 28.875,174.309 18,174.094 C18,174.094 27.341,174.19 27.096,182.926 C27.096,182.926 27.936,176.053 36.508,174.518 C36.508,174.518 29.264,176.18 27.569,165",
    id: "Fill-22",
    fill: "#1352DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.569,56 C174.569,56 175.874,65.309 165,65.094 C165,65.094 174.341,65.19 174.096,73.925 C174.096,73.925 174.935,67.053 183.507,65.518 C183.507,65.518 176.264,67.18 174.569,56",
    id: "Fill-23",
    fill: "#C7DBF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.335,80 C220.335,80 220.79,83.244 217,83.17 C217,83.17 220.256,83.203 220.169,86.248 C220.169,86.248 220.462,83.853 223.45,83.317 C223.45,83.317 220.925,83.896 220.335,80",
    id: "Fill-24",
    fill: "#1352DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.335,123 C36.335,123 36.79,126.244 33,126.17 C33,126.17 36.256,126.203 36.169,129.248 C36.169,129.248 36.462,126.853 39.45,126.317 C39.45,126.317 36.925,126.896 36.335,123",
    id: "Fill-24-Copy-2",
    fill: "#1352DE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.335,2.88657986e-14 C84.335,2.88657986e-14 84.79,3.244 81,3.17 C81,3.17 84.256,3.203 84.169,6.248 C84.169,6.248 84.462,3.853 87.45,3.317 C87.45,3.317 84.925,3.896 84.335,2.88657986e-14",
    id: "Fill-24-Copy-3",
    fill: "#1352DE"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#1352DE",
    cx: 127,
    cy: 30,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-2",
    stroke: "#C7DBF4",
    cx: 2.5,
    cy: 83.5,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-3",
    stroke: "#1352DE",
    cx: 148,
    cy: 184,
    r: 2.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-10",
    transform: "translate(60.000000, 63.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(1.000000, 1.000000)",
    fill: "#C7DBF4",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.826087,100.51755 L16.826087,29.2007596 C16.826087,14.7304354 28.5111687,3 42.9256661,3 L27.033913,3 C21.5385134,3 12.8534849,-0.00992095505 8.64268434,0.9625 C1.77701859,2.54802206 0.86,9.4917285 0.86,18.4647887 C0.86,28.1156906 0.86,55.4630289 0.86,100.506804 C0.86,114.982894 -0.568471045,124.32414 13.8871194,124.32414 C23.5241797,124.32414 33.2036952,124.32414 42.9256661,124.32414 C28.5111687,124.32414 16.826087,114.987874 16.826087,100.51755 Z",
    id: "Path"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#C7DBF4",
    fillRule: "nonzero",
    cx: 29.5,
    cy: 52.5,
    r: 5.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.6774194,43 L68.6290323,43 C58.3569839,43 50,34.6430161 50,24.3709677 L50,15.3225806 C50,12.3829194 52.3829194,10 55.3225806,10 C58.2622419,10 60.6451613,12.3829194 60.6451613,15.3225806 L60.6451613,24.3709677 C60.6451613,28.7732742 64.2267258,32.3548387 68.6290323,32.3548387 L77.6774194,32.3548387 C80.6170806,32.3548387 83,34.7377581 83,37.6774194 C83,40.6170806 80.6170806,43 77.6774194,43 Z",
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 6,
    fill: "#1352DE",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.7191011,80 L27.2808989,80 C24.3642584,80 22,77.98535 22,75.5 C22,73.01465 24.3642584,71 27.2808989,71 L63.7191011,71 C66.6357416,71 69,73.01465 69,75.5 C69,77.98535 66.6357416,80 63.7191011,80 Z",
    id: "Path",
    fill: "#C7DBF4",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.7191011,98 L27.2808989,98 C24.3642584,98 22,95.98535 22,93.5 C22,91.01465 24.3642584,89 27.2808989,89 L63.7191011,89 C66.6357416,89 69,91.01465 69,93.5 C69,95.98535 66.6357416,98 63.7191011,98 Z",
    id: "Path-Copy",
    fill: "#C7DBF4",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#1352DE",
    strokeWidth: 4,
    x: 2,
    y: 2,
    width: 88,
    height: 123,
    rx: 11
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-16-Copy-7",
    transform: "translate(62.000000, 94.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy",
    stroke: "#FFFFFF",
    strokeWidth: 5,
    fill: "#13AA41",
    cx: 21.5,
    cy: 21.5,
    r: 19
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\u269B\\uFE0F-Atom-/-Indicator-/-Requirements-Good-Copy-4",
    transform: "translate(11.000000, 12.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Check",
    fill: "#13AA41",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "\\uD83D\\uDD35-Color-/-Green-/-3-Dark",
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-10.959608, -10.959608)",
    id: "Dark-Green"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-4)",
    xlinkHref: "#path-3"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "#E0E5EB",
    strokeWidth: 1,
    strokeLinejoin: "square",
    fill: "#FFFFFF",
    fillRule: "evenodd",
    x: 0.5,
    y: 0.5,
    width: 39.8494492,
    height: 39.8494492
  })))))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfirmationIcon);
export default __webpack_public_path__ + "static/media/Confirmation_Icon.e0418c8fb08899f440bad7e5f819cdaf.svg";
export { ForwardRef as ReactComponent };